<template>
  <div class="app-container">
    <div v-if="!showAddOrUpdate" class="container">
      <div class="filter" v-if="roles">
        <div class="filter-select">
          <div class="fliter-cell">
            <div class="filter-title">供应商名称</div>
            <div class="select-width" style="width:150px">
              <el-input
                placeholder="请输入供应商名称"
                v-model="listQuery.searchName"
                size="mini"
                clearable
              >
              </el-input>
            </div>
          </div>

          <div class="fliter-cell">
            <div class="filter-title">供应商服务类型</div>
            <div class="select-width">
              <el-select
                v-model="listQuery.category"
                placeholder="全部"
                size="mini"
                style="width:100%"
              >
                <el-option
                  v-for="item in category.list1"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="fliter-cell">
            <div class="filter-title">审批状态</div>
            <div class="select-width">
              <el-select
                v-model="listQuery.state"
                placeholder="全部"
                size="mini"
                style="width:100%"
              >
                <el-option
                  v-for="item in stateOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.state"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="fliter-cell">
            <div class="filter-title">认证品牌</div>
            <div class="select-width">
              <el-select
                v-model="listQuery.lists"
                filterable
                placeholder="全部"
                size="mini"
                style="width:100%"
              >
                <el-option
                  v-for="(item, index) in logoOptions.list1"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="filter-title" @click="vendorSort">
            以供应商排序
            <el-button type="text" icon="el-icon-d-caret"></el-button>
          </div>
        </div>
        <div class="filter-btn">
          <el-button
            class="button"
            type="primary"
            plain
            size="mini"
            @click="exportVendor"
            >导出</el-button
          >
          <el-button
            class="button"
            type="primary"
            plain
            size="mini"
            @click="importVendor"
            >导入</el-button
          >
          <el-button
            class="button"
            type="primary"
            plain
            size="mini"
            @click="queryClick"
            >查询</el-button
          >
          <el-button class="button" plain size="mini" @click="resetProvider"
            >重置</el-button
          >
          <!--          <el-button class="button" type="primary" icon="el-icon-plus" size="mini" @click="addProvider">新增</el-button>-->
        </div>
      </div>
      <!-- 列表  -->
      <div class="pagecontent">
        <el-table
          :data="tableData"
          style="width: 100%"
          stripe
          v-loading="listLoading"
        >
          <el-table-column
            type="index"
            label="排序"
            width="70"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="供应商名称"
            width="120"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="qualificationsNames"
            label="资质"
            width="160"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="servedBrandsName"
            label="认证品牌"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="cooperateStatus"
            label="B2B合作状态"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <span class="mycolor" v-if="scope.row.cooperateStatus == 0">正在合作</span>
              <span class="myredcolor" v-else>未合作</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="active"
            label="B2B是否生效"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <span class="mycolor" v-if="scope.row.active == 0">生效</span>
              <span class="myredcolor" v-else>失效</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="state"
            label="审批状态"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <span class="mycolor" v-if="scope.row.state != 3">{{
                formatState(scope.row.state)
              }}</span>
              <span class="myredcolor" v-else>{{
                formatState(scope.row.state)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="state"
            label="上架状态"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <span class="mycolor" v-if="scope.row.delFlag == 0">已上架</span>
              <span class="myredcolor" v-else>已下架</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="roles"
                @click.native.prevent="approveRow(scope.row)"
                type="text"
                size="small"
                :disabled="scope.row.state == 2"
              >
                <span
                  :class="
                    scope.row.state == 2
                      ? 'mygraycolor gray-text'
                      : 'mycolor blue-text'
                  "
                  >通过</span
                >
              </el-button>
              <el-button
                v-if="roles"
                @click.native.prevent="approveRow1(scope.row)"
                type="text"
                size="small"
                :disabled="scope.row.state == 3"
              >
                <span
                  :class="
                    scope.row.state == 3
                      ? 'mygraycolor gray-text'
                      : 'mycolor blue-text'
                  "
                  >驳回</span
                >
              </el-button>
              <el-button
                @click.native.prevent="showRow(scope.row)"
                type="text"
                size="small"
              >
                <span class="blue-text">查看</span>
              </el-button>
              <el-button
                @click.native.prevent="offShelf(scope.row)"
                type="text"
                size="small"
                v-if="roles"
              >
                <span class="blue-text" v-if="scope.row.delFlag == 0"
                  >下架</span
                >
                <span class="blue-text" v-else>上架</span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--  -->
      <div class="paging">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <div v-if="showAddOrUpdate" class="baseinfo">
      <el-row class="lrflex" :gutter="20">
        <el-col :span="24" class="left-content">
          <div class="baseinfo-title">基本信息</div>
          <div class="solid"></div>
          <el-form
            :model="ruleForm"
            :rules="ruleFormFules"
            ref="ruleForm"
            label-width="140px"
            class="demo-ruleForm"
            label-position="left"
          >
            <el-form-item
              label="驳回原因"
              v-if="ruleForm.state == 3 && !isadd"
              prop="reject"
            >
              <div class="width304">
                <el-input
                  v-model="ruleForm.reject"
                  size="mini"
                  :title="ruleForm.reject"
                  placeholder="驳回原因是"
                  :disabled="!roles"
                  style="width:100%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="供应商名称" prop="name">
              <div class="width304">
                <el-input
                  disabled
                  v-model="ruleForm.name"
                  size="mini"
                  placeholder="请输入名称"
                  style="width:100%"
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item
              label="供应商资质"
              :prop="roles ? 'noprop': 'qualificationsNames'"
            >
              <el-tag 
                :key="tag.code"
                v-for="(tag, index) in qualificationsTags"
                :disable-transitions="false" 
                closable 
                @close="handleQTagClose(tag, index)"
                >{{ tag }}
              </el-tag>

              <el-select
            
                v-model="ruleForm.qualificationsNames"
                size="mini"
                filterable
                placeholder="全部"
                @change="addQulificationsTags"
              >
                <el-option
                  v-for="(item, index) in aptitudeOptions"
                  :key="index"
                  :label="item.name"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item> 
            
            <!--:prop="!roles ? 'noprop': 'businessTypeNames'"-->
            <el-form-item
              label="供应商业务类型"
            >
              <el-tag 
                :key="tag.code"
                v-for="(tag, index) in businessTypeTags"
                :disable-transitions="false" 
                closable 
                @close="handleBTagClose(tag, index)"
                >{{ tag }}
              </el-tag>

              <el-select   
                v-if="roles"
                v-model="ruleForm.businessTypeNames"
                size="mini"
                placeholder="全部"
                @change="addBusinessTypeTags"
              >
                <el-option
                  v-for="(item, index) in businessTypeOptions"
                  :key="index"
                  :label="item.name" 
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item> 

            <el-form-item label="大区"  :prop="!roles ?  'noprop':'largeArea' ">
              <el-tag 
                :key="index"
                v-for="(tag, index) in largeAreaTags"
                :disable-transitions="false"
                closable 
                @close="handleLargeAreaTagsClose(tag, index)"
                >{{ tag }}
              </el-tag>

              <el-select 
                v-if="roles "
                v-model="ruleForm.largeAreaNames"
                size="mini"
                filterable
                placeholder="选择大区"
                @change="addLargeAreas"
              >
                <el-option
                  v-for="(item, index) in largeAreaList"
                  :key="index"
                  :label="item.name"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="优采会员">
              <div class="width304">
                <el-select 
                  disabled
                  v-model="ruleForm.youcaiMember"
                  placeholder="选择是否优采会员"
                  size="mini"
                >
                  <el-option
                    v-for="item in [
                      { name: '是', id: '1' },
                      { name: '否', id: '2' }
                    ]"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
             <!-- :prop="!roles ?  'noprop':'restAssured' " -->
            <el-form-item label="安心用" >
            
              <div class="width304">
                <el-select 
                  :disabled="!roles"
                  v-model="ruleForm.restAssured"
                  placeholder="选择是否安心用"
                  size="mini"
                >
                  <el-option
                    v-for="item in [
                      { name: '是', id: '1' },
                      { name: '否', id: '2' }
                    ]"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="优势服务省份"  
             :prop="!roles ? 'advantageousServiceProvinces':'noprop'">
              <div class="width304">
                <el-input
                  v-model="ruleForm.advantageousServiceProvinces"
                  size="mini"
                  placeholder="请输入优势服务省份"
                  style="width:100%"
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item label="供应商标签"  >
              <div class="width304">
                <el-input
                  v-model="ruleForm.vendorLabel"
                  size="mini"
                   :disabled="!roles"
                  placeholder="请输入供应商标签并以英文逗号作为空格"
                  style="width:100%"
                ></el-input>
              </div>
            </el-form-item>


            <el-form-item
              label="认证品牌"
              :prop="!roles ?  'noprop' :'servedBrandsName'"
            >
              <el-select
                size="mini"
                :disabled="!roles"
                v-model="selectBrands"
                multiple
                collapse-tags
                placeholder="请选择认证品牌"
              >
                <div class="select-brand-all">
                  <el-checkbox v-model="isSelectAll" @change="brandSelectAll"
                    >全选</el-checkbox
                  >
                </div>
                <el-option
                  v-for="item in brandList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="联系地址"
              :prop="!roles ? 'regionName' : 'noprop'"
            >
              <div class="address_style">
                <div class="width164">
                  <el-select
                    v-model="ruleForm.regionName"
                    @change="getadress"
                    size="small"
                    filterable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in addressoptions.list1"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </div>
                <div class="address-right" v-if="iscity">
                  <el-select
                    v-model="vicecaseList.cityName"
                    @change="citygetadress"
                    filterable
                    size="small"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in addressoptions.list2"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                  <div class>
                    <el-input
                      v-model="vicecaseList.betterAddress"
                      placeholder="详细地址"
                      size="small"
                    ></el-input>
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item
              label="联系方式"
              :prop="!roles ? 'contact' : 'noprop'"
            >
              <div class="width164">
                <el-input
                  v-model="ruleForm.contact"
                  size="mini"
                  style="width:100%"
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item
              label="成立时间"
              :prop="!roles ? 'establishTime' : 'noprop'"
            >
              <div class="width220">
                <el-date-picker
                  class="myright_2"
                  v-model="ruleForm.establishTime"
                  size="mini"
                  type="date"
                  @change="chantime"
                  style="width:82%"
                  format="yyyy 年 MM 月 dd 日"
                  placeholder="选择日期"
                ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item
              label="年营业额"
              :prop="!roles ? 'turnOver' : 'noprop'"
            >
              <div class="width164">
                <el-input
                  v-model="ruleForm.turnOver"
                  size="mini"
                  style="width:70%"
                ></el-input>
                <span class="input_right">万元</span>
              </div>
            </el-form-item>
            <el-form-item
              label="注册资金"
              :prop="!roles ? 'registerCapital' : 'noprop'"
            >
              <div class="width164">
                <el-input
                  v-model="ruleForm.registerCapital"
                  size="mini"
                  style="width:70%"
                ></el-input>
                <span class="input_right">万元</span>
              </div>
            </el-form-item>
            <el-form-item
              label="认证项目经理数"
              :prop="!roles ? 'certifiedCount' : 'noprop'"
            >
              <div class="width304">
                <el-input
                  type="number"
                  :min="0"
                  v-model="ruleForm.certifiedCount"
                  size="mini"
                  style="width:100%"
                >
                </el-input>
              </div>
            </el-form-item>
            <!-- <el-form-item v-if="roles" label="服务地区" :prop="!roles ? 'servedRegionsNames' : 'noprop'">
              <el-tag :key="index" v-for="(tag, index) in dynamicTags" closable :disable-transitions="false"
                @close="handleTagClose(tag, index)">{{ tag }}
              </el-tag>

              <el-select v-model="ruleForm.servedRegionsNames" placeholder="选择省份" size="mini" @change="addTags">
                <el-option v-for="item in regionSptions" :key="item.code" :label="item.name" :value="item"></el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item  label="全国绩效" prop="rankingPriority">
              <div class="width304" style>
                <el-input 
                  disable 
                  v-model="ruleForm.rankingPriority"
                  size="mini"
                  placeholder="请输入全国绩效"
                ></el-input>
              </div>
            </el-form-item>
            <!-- category -->
            <el-form-item
              label="供应商服务类型"
              :prop="!roles ? 'category' : 'noprop'"
            >
              <div class="width304">
                <el-select
                  v-model="ruleForm.category"
                  placeholder="选择供应商类型"
                  size="mini"
                  @change="categorysel"
                >
                  <el-option
                    v-for="item in category.list2"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="近两年项目数" prop="projectsInTwoYears">
              <div class="width304" style>
                <el-input
                  type="text"
                  disabled
                  oninput="value=value.replace(/[^0-9]/g,'')"
                  v-model="ruleForm.projectsInTwoYears"
                  size="mini"
                  placeholder="请输入近两年项目数"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="质保金" prop="warrantyDepositField">
              <div class="width304" style>
                <el-input
                  type="text"
                  disabled
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  v-model="ruleForm.warrantyDepositField"
                  size="mini"
                  placeholder="请输入质保金"
                ></el-input>
              </div>
            </el-form-item>
            <!-- 图片 -->
            <div class="outimg">
              (图片上传请选择jpg/png文件，大小不超过800*600)
            </div>
            <div>
              <el-form-item label="供应商首图">
                <div class="upload-image">
                  <el-upload
                    ref="uploadimg1"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview1"
                    :on-remove="handleRemove1"
                    :on-change="onChange1"
                    :auto-upload="false"
                    :data="imgdata1"
                    :action="img_url1"
                    accept="image/png, image/jpeg"
                    :show-file-list="true"
                    size="mini"
                    :file-list="ruleForm.dialogImageUrlArray1"
                  >
                    <img
                      v-if="imageUrlIdPhone"
                      :src="imageUrlIdPhone"
                      class="avatar"
                    />
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div>
                    <el-dialog :visible.sync="form.dialogVisible1" size="tiny">
                      <img width="100%" :src="form.imageUrlIdPhone" alt />
                    </el-dialog>
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="企业资质">
                <div class="upload-image">
                  <el-upload
                    list-type="picture-card"
                    :auto-upload="false"
                    :action="img_url2"
                    ref="uploadimg2"
                    accept="image/png, image/jpeg"
                    :show-file-list="true"
                    size="mini"
                    :on-change="onChange2"
                    :on-preview="handlePictureCardPreview1"
                    :on-remove="handleRemove2"
                    :file-list="ruleForm.dialogImageUrlArray2"
                    :data="imgdata2"
                  >
                    <img
                      v-if="imageUrlIdPhone"
                      :src="imageUrlIdPhone"
                      class="avatar"
                    />
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div>
                    <el-dialog :visible.sync="form.dialogVisible1" size="tiny">
                      <img width="100%" :src="form.imageUrlIdPhone" alt />
                    </el-dialog>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="行业声誉&客户满意度">
                <div class="upload-image">
                  <el-upload
                    :on-success="uthenticationSuccess"
                    name="files"
                    list-type="picture-card"
                    :auto-upload="true"
                    :action="img_url3"
                    ref="uploadimg3"
                    accept="image/png, image/jpeg"
                    :show-file-list="true"
                    :file-list="copyAuthenticationPictures"
                    size="mini"
                    :on-remove="handleRemove3"
                  >
                    <img
                      v-if="imageUrlIdPhone"
                      :src="imageUrlIdPhone"
                      class="avatar"
                    />
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div>
                    <!-- <el-dialog :visible.sync="form.dialogVisible1" size="tiny">
                      <img width="100%" :src="form.imageUrlIdPhone" alt />
                    </el-dialog> -->
                  </div>
                </div>
              </el-form-item>
            </div>

            <!-- <div class="outimg">(视频上传请选择mp4文件，大小不超过300M，最多可以上传1个视频)</div>
            <div>
              <el-form-item label="供应商宣传视频">
                <div class="upload-image">
                  <el-upload name="file" v-if="!videoPath" list-type="picture-card" :auto-upload="true"
                             :action="vedio_url" ref="uploadimg3" :show-file-list="false"
                             :on-progress="uploadVideoProcess" :on-success="handleVideoSuccess"
                             :before-upload="beforeUploadVideo">

                    <i v-if="videoPath == '' && !videoFlag" class="el-icon-plus avatar-uploader-icon"></i>
                    <el-progress v-if="videoFlag" type="circle" :percentage="videoUploadPercent"
                                 style="margin-top:7px;"></el-progress>
                  </el-upload>
                  <div class="video-box" v-if="videoPath != '' && !videoFlag">
                    <video :src="videoPath" class="avatar video-avatar" controls="controls">
                      您的浏览器不支持视频播放
                    </video>
                    <i class="el-icon-delete video-delete" @click="videoRemove"></i>
                  </div>


                  <div>
                  </div>
                </div>
              </el-form-item>
            </div> -->

            <el-form-item label="负责人&项目经理">
              <el-button @click="changePrincipal" type="primary" size="mini"
                >添加负责人&项目经理信息</el-button
              >
              <div class="principal-list">
                <div
                  class="principal-item"
                  v-for="(item, index) in ruleForm.principal"
                >
                  <i
                    @click="deletePrincipalItem(index)"
                    style="color:#e03131"
                    class="el-icon-delete delete-principal-item"
                  ></i>
                  <img :src="item.img" alt="" />
                  <div class="info">
                    <span>姓名：{{ item.name }}</span>
                    <span>职位：{{ item.remark }}</span>
                  </div>
                </div>
              </div>
              <!-- <el-dialog :visible.sync="form.dialogVisible1" size="tiny">
                      <img width="100%" :src="form.imageUrlIdPhone" alt />
                    </el-dialog> -->
              <div></div>
            </el-form-item>
            <el-form-item
              label="施工单位简介"
              :prop="!roles ? 'description' : 'noprop'"
            >
              <div class="width650">
                <el-input
                  type="textarea"
                  :rows="10"
                  v-model="ruleForm.description"
                  style="width:100%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="bottom-btn">
                <el-button @click="cancleForm" size="mini">返回</el-button>
                <span style="margin-right:64px"></span>
                <el-button
                  :loading="loading"
                  type="primary"
                  @click="submitForm('ruleForm')"
                  size="mini"
                  >提交</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      @close="principaDialogClose"
      title="负责人&项目经理信息"
      :visible.sync="principalShow"
      width="30%"
      :lock-scroll="false"
    >
      <!-- <span></span> -->
      <el-form ref="form" :model="principalForm" label-width="80px">
        <el-form-item label="姓名">
          <el-input v-model="principalForm.name"></el-input>
        </el-form-item>
        <el-form-item label="职位">
          <el-input v-model="principalForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="工作年限">
          <el-input v-model="principalForm.yearsOfService"></el-input>
        </el-form-item>
        <el-form-item label="区域">
          <el-input v-model="principalForm.area"></el-input>
        </el-form-item>
        <el-form-item label="品牌">
          <el-input v-model="principalForm.brand"></el-input>
        </el-form-item>
        <el-form-item label="项目数量">
          <el-input v-model="principalForm.itemQuantity"></el-input>
        </el-form-item>
		    <el-form-item label="照片">
          <div class="upload-image">
            <el-upload
              :multiple="false"
              :limit="1"
              :on-success="principalUrlSuccess"
              name="files"
              list-type="picture-card"
              :auto-upload="true"
              :action="img_url3"
              ref="uploadimg3"
              :show-file-list="true"
              :file-list="principalFilList"
              size="mini"
              :on-remove="principalUrlRemove"
            >
              <img
                v-if="imageUrlIdPhone"
                :src="imageUrlIdPhone"
                class="avatar"
              />
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div>
            </div>
          </div>
        </el-form-item>        
        <el-form-item label="认证证书">
          <div class="upload-image">
            <el-upload
              :multiple="false"
              :on-success="principalCertificateUrlSuccess"
              name="files"
              list-type="picture-card"
              :auto-upload="true"
              :action="img_url3"
              ref="uploadimg3"
              :show-file-list="true"
              :file-list="principalCertificateFilList"
              size="mini"
              :on-remove="principalCertificateUrlRemove"
            >
              <img
                v-if="imageUrlIdPhone"
                :src="imageUrlIdPhone"
                class="avatar"
              />
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="principalShow = false">取 消</el-button>
        <el-button type="primary" @click="savePrincipalForm">保 存 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { weburl } from "@/utils/request";
import BrandInfoModal from "@/components/BrandInfoModal/index.vue";
import { getToken } from "@/utils/auth";
import {
  addVendor,
  deleteVendor,
  exportVendorExcel,
  imgQuery,
  importVendorExcel,
  queryCity,
  queryIdVendor,
  queryLogoAll,
  queryQualification,
  queryRegionList,
  queryVendorList,
  updateVendor,
  updateVendorState,
  vendorcategoryList,
  vendoremove,
  vshowVendor,
  getLargeAreaList,
  showBrandsBySearchName
} from "@/api/api";
import moment from "moment";

export default {
  components: {
    BrandInfoModal
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
  },
  data() {
    var ruleranking = (rule, value, cal) => {
      if (value <= 10 && value > 0) {
        cal();
      } else {
        cal(new Error("请输入数字1~10"));
      }
    };
    var ruleranking1 = (rule, value, cal) => {
      let a = this.dynamicTags;
      console.log(a, "123124");
      if (a.length > 0) {
        cal();
      } else {
        cal(new Error("请选择服务地区"));
      }
    };
    var ruleranking2 = (rule, value, cal) => {
      let a = this.selectBrands || "";
      if (a.length > 0) {
        cal();
      } else {
        cal(new Error("请选择服务品牌"));
      }
    };
    var ruleranking3 = (rule, value, cal) => {
      let a = this.qualificationsTags || "";
      console.log("change data", a);
      if (a.length > 0) {
        cal();
      } else {
        cal(new Error("请选择供应商资质"));
      }
    };
    var ruleranking5 =  (rule, value, cal) => {
      let a = this.businessTypeTags || "";
      console.log("change data", a);
      if (a.length > 0) {
        cal();
      } else {
        cal(new Error("请选择供应商业务类型"));
      }
    };
    var ruleranking4 = (rule, value, cal) => {
      let a = this.largeAreaTags || "";
      console.log("change data", a);
      if (a.length > 0) {
        cal();
      } else {
        cal(new Error("请选择大区"));
      }
    };
    return {
      selectBrands: [],
      brandList: [],
      videoFlag: false,
      //是否显示进度条
      videoUploadPercent: "",
      //进度条的进度，
      isShowUploadVideo: false,
      videoPath: "",
      BrandInfoModal: false,
      principalFilList: [],
      principalCertificateFilList:[],
      principalForm: {
        name: "",
        remark: "",
        img: "",
        yearsOfService:"",
        itemQuantity:"",
        area:"",
        brand:"",
        authenticationCertificate:[]
      },
      principalShow: false,
      getToken,
      loading: false,
      // 是否新增
      isadd: false,
      // 供应商类型下拉
      category: {
        list1: [],
        list2: []
      },
      // 状态下拉
      stateOptions: [
        { label: "全部", state: 0 },
        { label: "待审批", state: 1 },
        { label: "已通过", state: 2 },
        { label: "已驳回", state: 3 },
        { label: "已下架", state: 4 }
      ],
      // 品牌下拉
      logoOptions: {
        list1: [],
        list2: []
      },
      // 地区
      regionSptions: [],
      // 资质下拉
      aptitudeOptions: [],
      businessTypeOptions:[{id:"装配式",code:"装配式",name:"装配式"},{id:"翻新改造",code:"翻新改造",name:"翻新改造"}],
      form: {
        dialogImageUrl: "", // 头像
        imageUrlIdPhone: "", // 证件照
        dialogVisible: false,
        dialogVisible1: false
      },
      listLoading: true,
      dialogImageUrl: "",

      listQuery: {
        category: "",
        lists: "",
        state: 0,
        s: "",
        sort: 0,
        pageSize: 10,
        pageNum: 1,
        searchName: "",
        priority: 0
      },

      tableData: [],

      currentPage: 1,
      dialogVisibleBanner: false,
      dialogVisibleQu: false,
      showAddOrUpdate: false,
      largeAreaList: [],
      ruleForm: {
        reject: "",
        name: "",
        establishTime: "",
        qualifications: [],
        businessType:[],
        servedBrands: [],
        dynamicTags: [],
        contact: "",
        servedRegions: [],
        largeArea: [],
        youcaiMember: "",
        restAssured:"",
        advantageousServiceProvinces: "",
        vendorLabel:"",
        turnOver: "",
        // 省份
        description: "",
        category: "",
        qualificationsNames: "",
        businessTypeNames: "",
        servedRegionsNames: "",
        servedBrandsName: "",
        largeAreaNames: "",
        dialogImageUrlArray1: [],
        registerCapital: "",
        dialogImageUrlArray2: [],
        rankingPriority: "",
        certifiedCount: "",
        authenticationPictures: [],
        principal: [],
        projectsInTwoYears: "", //近两年项目数,
        warrantyDepositField: "" //质保金
      },
      copyAuthenticationPictures: [],
      vicecaseList: {
        cityName: "",
        cityId: "", // 城市code
        regionId: "", // 省code
        regionName: "",
        betterAddress: "" // 详细地址
      },
      iscity: false,
      // 办公地点
      addressoptions: {
        list1: [],
        list2: []
      },

      // 默认标签
      dynamicTags: [],
      servedBrandstags: [],
      qualificationsTags: [],
      businessTypeTags : [],
      largeAreaTags: [],
      inputVisible: false,
      inputValue: "",
      // 省份
      provinces: [],
      total: 0,
      // // 上传banner
      // uploadBannerData: {},
      // // 上传资质图
      // uploadQuData: {},

      img_url1: "/v1/vendor/addBanners",
      img_url2: "/v1/vendor/addQualifications",
      img_url3: `${weburl}/v1/vendor/addVendorAuthenticationPictures/file`,
      vedio_url: `${weburl}/v1/vendor/uploadVideo/file`,

      imgdata1: {
        name: ""
      },
      imgdata2: {
        name: ""
      },
      imgdata3: {
        name: ""
      },
      imageUrlIdPhone: "",
      dialogImageUrlArray1: [],
      dialogImageUrlArray2: [],
      form1: {
        dialogImageUrl: "", // 头像
        imageUrlIdPhone: "", // 证件照
        dialogVisible: false,
        dialogVisible1: false
      },
      form2: {
        dialogImageUrl: "", // 头像
        imageUrlIdPhone: "", // 证件照
        dialogVisible: false,
        dialogVisible1: false
      },

      userinfo: {},
      role: "",
      ruleFormFules: {
        // 管理员
        noprop: [{ required: false }],
        reject: [{ required: true, message: "驳回原因", trigger: "blur" }],
        name: [
          { required: false, message: "请输入供应商名字", trigger: "blur" }
        ],
        contact: [
          { required: true, message: "请输入供应商名字", trigger: "blur" }
        ],
        regionName: [
          { required: true, message: "地址不能为空", trigger: "blur" }
        ],
        youcaiMember: [{ required: true, message: "请选择是否优采会员" }],
        restAssured: [{ required: true, message: "请选择是否安心用" }],
        advantageousServiceProvinces: [{ required: true, message: "请输入优势服务省份" }],
        largeArea: [{ required: true, message: "请选择大区" }],
        establishTime: [
          {
            required: true,
            message: "成立时间不为空",
            trigger: "blur"
          }
        ],
        certifiedCount: [
          { required: true, message: "项目经理不为空", trigger: "blur" }
        ],
        // 资质
        qualificationsNames: [
          { required: true, trigger: "change", validator: ruleranking3 }
        ],
        // 供应商业务类型
        businessTypeNames: [
          { required: true, trigger: "change", validator: ruleranking5 }
        ],
        largeAreaNames: [
          { required: true, trigger: "change", validator: ruleranking4 }
        ],
        // 品牌
        servedBrandsName: [
          { required: true, trigger: "change", validator: ruleranking2 }
        ],
        // 服务地区
        servedRegionsNames: [
          {
            required: true,
            trigger: "change",
            validator: ruleranking1
          }
        ],
        registerCapital: [
          { required: true, message: "请输入注册资金", trigger: "blur" }
        ],
        rankingPriority: [
          // { required: true, message: "综合排名不为空", trigger: "blur" }
          // {
          //   validator: ruleranking,
          //   trigger: "blur"
          // }
        ],
        description: [
          { required: true, message: "简介不为空", trigger: "blur" }
        ],
        turnOver: [
          { required: true, message: "年营业额不为空", trigger: "blur" }
        ],
        category: [
          { required: true, message: "请选择供应商类型", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    roles() {
      return this.role.admin == this.userinfo.role;
    },
    isSelectAll:{
      get(){
        return this.selectBrands.length === this.brandList.length
      },
      set(){
      }
    }
  },
  created() {
    this.rolechange();
    this.fetchData();
    // this.role = this.$store.getters.role;
    this.getList();
    this.getBrands();
    // console.log("时间", moment().format("yyyy-MM-DD HH:mm:ss"));

    if (this.roles) {
      imgQuery({ id: this.userinfo.role }).then(res => {
        if (res.data.code === 0) {
          let da = res.data.data;
          // this.dialogImageUrlArray = da.banners.split(',')
          let a = da.banners;
          let arr = a ? a.split(",") : [];
          let arrs1 = [];
          arr.forEach(item => {
            let obj = {
              url: item
            };
            arrs1.push(obj);
          });
          this.dialogImageUrlArray1 = arrs1;
        }
      });
    } else {
      imgQuery({ id: this.role.vander }).then(res => {
        if (res.data.code === 0) {
          let da = res.data.data;
          console.log("12321321", da);
          // this.dialogImageUrlArray = da.banners.split(',')
          // let a = da.banners;
          // let arr = a ? a.split(",") : [];
          // let arr2 = [];
          // arr.forEach(item => {
          //   let obj = {
          //     url: item
          //   };
          //   arrs2.push(obj);
          // });
          // this.dialogImageUrlArray2 = arrs2;
        }
      });
    }
  },
  methods: {
    brandSelectAll(event) {
      if (event) {
        this.selectBrands = this.brandList.map(item => item.code);
      } else {
        this.selectBrands = [];
      }
    },
    async getBrands() {
      const result = await showBrandsBySearchName({ vendorCode: this.code });
      if (
        result.status === 200 &&
        result.data.code === 0 &&
        result.data &&
        result.data.data.length >= 0
      ) {
        this.brandList = result.data.data;
      } else {
        this.$message.warning("品牌信息获取失败");
      }
    },
    openBrandInfoModal() {
      this.BrandInfoModal = true;
    },
    vendorSort() {
      // 0是不排序,1是正序,2倒序
      this.listQuery.priority = this.listQuery.priority === 0 ? 2 : 0;
      this.getList(this.listQuery);
    },
    deletePrincipalItem: function(index) {
      this.ruleForm.principal.splice(index, 1);
    },
    savePrincipalForm: function() {
      if (
        !this.principalForm.name ||
        !this.principalForm.remark ||
		    !this.principalForm.img ||
        !this.principalForm.yearsOfService ||
        !this.principalForm.itemQuantity ||
        !this.principalForm.area ||
        !this.principalForm.brand ||
        !this.principalForm.authenticationCertificate ||
        !this.principalForm.authenticationCertificate.length > 0
      ) {
        return this.$message.error("负责人&项目经理信息缺失"); 
      }
      console.log(this.ruleForm.principal);
      this.ruleForm.principal.push(
        JSON.parse(JSON.stringify(this.principalForm))
      );
      this.principalShow = false;
      console.log(this.ruleForm.principal);
    },
    principalUrlSuccess: function(res) {
      this.principalForm.img  = res.data;
      // this.principalFilList = [{name:"test",url:res.data}];
    },
    principalCertificateUrlSuccess: function(res) {
        this.principalForm.authenticationCertificate = res.data;  
     },
    principalCertificateUrlRemove: function(file) {
      // console.log(file);
      let index = this.principalForm.authenticationCertificate.findIndex(
        ele => ele === file.url
      );
      if (index >= 0) {
        this.principalForm.authenticationCertificate.splice(index, 1);
      }
    },
    principalUrlRemove: function(file) {
      this.principalFilList = [];
      this.principalForm.img = "";
      this.principalCertificateFilList = [];
      this.principalForm.authenticationCertificate = "";
      // console.log(file);
    },
    principaDialogClose: function() {
      this.principalFilList = [];
      this.principalCertificateFilList = [];
      for (let i in this.principalForm) {
        this.principalForm[i] = "";
      }
    },
    changePrincipal: function() {
      this.principalShow = true;
    },
    handleRemove3: function(file) {
      // console.log(file);
      let index = this.ruleForm.authenticationPictures.findIndex(
        ele => ele === file.url
      );
      if (index >= 0) {
        this.ruleForm.authenticationPictures.splice(index, 1);
      }
    },
    uthenticationSuccess: function(response, file, fileList) {
      if (response.data) {
        this.ruleForm.authenticationPictures.push(response.data);
      }
    },
    exportVendor: async function(url) {
      const loading = this.$loading({
        lock: true,
        text: "加载中 请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let {
        category,
        lists,
        state,
        s,
        sort,
        pageSize,
        pageNum,
        searchName,
        priority
      } = this.listQuery;
      let params = {
        category: category != "" ? category : "0",
        lists: lists == 0 ? "" : lists,
        s: s != "" ? s : "0",
        sort,
        state,
        pageSize,
        pageNum,
        searchName,
        priority
      };
      const res = await exportVendorExcel(params);
      loading.close();
      if (res.status === 200) {
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/vnd.ms-excel" })
        );
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", "供应商基本数据.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$message.success("导出成功");
      } else {
        this.$message.error("导出失败");
      }
      console.log(res);
    },
    importVendor: function() {
      // this.$confirm("是否下载导入供应商模板？").then(res => {
      //   window.open('https://obs-b2b-1306055453.cos.ap-shanghai.myqcloud.com/b2b-vendor/%E4%BE%9B%E5%BA%94%E5%95%86%E6%B7%BB%E5%8A%A0%E6%A8%A1%E6%9D%BF.xlsx')
      //
      // }, error => {
      const iptObj = document.createElement("input");
      iptObj.setAttribute("type", "file");
      iptObj.setAttribute("id", "ipt");
      iptObj.setAttribute("style", "visibility:hidden");
      document.body.appendChild(iptObj);
      iptObj.click();
      iptObj.addEventListener("change", async e => {
        var file = e.target.files[0];
        var formdata = new FormData();
        // this.loading = true;
        const loading = this.$loading({
          lock: true,
          text: "加载中 请稍等",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        formdata.append("file", file, file.name);
        let result = await importVendorExcel(formdata);
        if (result.status === 200 && result.data.data >= 0) {
          if (result.data.code === -1) {
            this.$message.error(result.data.msg);
            loading.close();
            return;
          }
          this.getList();
          this.$message.success("导入成功");
        } else {
          this.$message.error("导入失败");
        }
        loading.close();
      });
      // })
    },
    chantime(e) {
      console.log(e, "时间");
      this.ruleForm.establishTime = moment(e).format("yyyy-MM-DD HH:mm:ss");
      console.log("转格式时间", this.ruleForm.establishTime);
    },
    // 当前行
    approveRow(rows) {
      if (rows.state === 1 || rows.state === 3) {
        this.$confirm("是否通过审批？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          // type: 'warning',
          center: true,
          showClose: false
        })
          .then(_ => {
            //   done()
            const p = {
              state: 2,
              reject: rows.reject,
              vendorId: rows.id
            };
            updateVendorState(p).then(res => {
              console.log(res.data.code);
              if (res.data.code === 0) {
                this.$message({
                  type: "success",
                  message: "审批通过"
                });
              }
              this.getList();
            });
          })
          .catch(_ => {
            this.$message({
              type: "info",
              message: "已取消通过审批"
            });
          });
      }
    },
    approveRow1(rows) {
      // 通过状态   console.log("index", rows);
      if (rows.state === 2 || rows.state === 1) {
        this.$prompt("请输入驳回理由", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          center: true,
          showClose: false
        })
          .then(({ value }) => {
            // 驳回状态

            const p = {
              state: 3,
              reject: value,
              vendorId: rows.id
            };
            if (value == null || value == "") {
              this.$message({
                type: "error",
                message: "输入不为空"
              });
            } else {
              updateVendorState(p)
                .then(res => {
                  if (res.data.code === 0) {
                    this.$message({
                      type: "success",
                      message: "驳回成功"
                    });
                  }

                  this.getList();
                })
                .catch(error => {
                  this.$message({
                    type: "error",
                    message: error
                  });
                });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消输入"
            });
          });
      }
    },
    getList() {
      this.listLoading = true;
      if (this.roles) {
        let {
          category,
          lists,
          state,
          s,
          sort,
          pageSize,
          pageNum,
          searchName,
          priority
        } = this.listQuery;
        //   category: 0,
        // lists: "",
        // state: 0,
        // s: "0",
        // sort: 0,
        // pageSize: 10,
        // pageNum: 1
        let params = {
          category: category != "" ? category : "0",
          lists: lists == 0 ? "" : lists,
          s: s != "" ? s : "0",
          sort,
          state,
          pageSize,
          pageNum,
          searchName,
          priority
        };
        queryVendorList(params).then(res => {
          console.log("tabledata", res);
          const da = res.data.data;
          this.tableData = da.list;
          this.total = da.total;
          this.listLoading = false;
        });
      } else {
        console.log("vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv");
        vshowVendor({
          vondorId: this.userinfo.vendor,
          pageSize: "10",
          pageNum: "1"
        }).then(res => {
          const da = res.data.data;
          console.log("接收值", da);
          // let arr= [];
          // da = da.push(da)
          this.tableData = da.list;
          this.total = da.total;
          this.listLoading = false;
        });
      }
    },
    // 下架
    offShelf(val) {
      console.log("删除案例", val);
      let my_state = "",
        id = 0,
        alert = "";
      if (val.delFlag == 0) {
        my_state = "是否下架该项目";
        alert = "下架成功";
        id = 1;
      } else {
        my_state = "是否上架该项目";
        alert = "上架成功";
        id = 0;
      }
      this.$confirm(my_state, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          vendoremove({ id: val.id, delFlag: id }).then(res => {
            console.log(res);
            if (res.status == 200) {
              this.getList();
              this.$message({
                type: "success",
                message: alert
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 获取权限
    rolechange() {
      this.role = this.$store.getters.role;
      let a = this.$store.getters.userinfo;
      if (!a.role) {
        this.userinfo = JSON.parse(a);
      } else {
        this.userinfo = a;
      }
      console.log("权限比较", this.userinfo, this.role.admin, this.roles);
    },

    async fetchData() {
      this.listLoading = true;
      // 查询供应商类别接口
      const vendorResponse = await vendorcategoryList();
      if (vendorResponse.status === 200) {
        this.category.list1 = vendorResponse.data.data;
        this.category.list2 = this.category.list1.filter(item => item.id != 0);
        console.log(this.options, "供应商下拉");
      }
      // 查询供应商品牌接口 需要默认pageNum 和pageSize
      const logoList = await queryLogoAll({ pageSize: "9999", pageNum: 1 });
      if (logoList.status == 200 || logoList.data.list.length > 0) {
        let arrs = logoList.data.list;

        this.logoOptions.list1 = JSON.parse(JSON.stringify(arrs));
        this.logoOptions.list1.unshift({ code: "", name: "全部" });
        this.logoOptions.list2 = arrs;
      }
      // 查询地区接口 需要默认pageNum 和pageSize
      const regionList = await queryRegionList();
      if (regionList.status === 200) {
        this.regionSptions = regionList.data.data;
        this.addressoptions.list1 = regionList.data.data;
      }
      // 查询资质
      const qualificationsList = await queryQualification();
      if (
        qualificationsList.status === 200 ||
        qualificationsList.data.data.length > 0
      ) {
        this.aptitudeOptions = qualificationsList.data.data;
      }
      this.listLoading = false;
      const largeAreaResult = await getLargeAreaList();
      console.log("大区信息获取失败:", largeAreaResult);
      if (
        largeAreaResult.status === 200 &&
        largeAreaResult.data.code === 0 &&
        largeAreaResult.data &&
        largeAreaResult.data.data.length > 0
      ) {
        this.largeAreaList = largeAreaResult.data.data;
      } else {
        this.$message.warning("大区信息获取失败");
      }
    },
    // 策略模式
    formatState(value) {
      const obj = {
        1: "待审批",
        2: "已通过",
        3: "已驳回",
        4: "已下架"
      };
      return obj[value];
    },
    // 查询
    queryClick() {
      // const p = this.listQuery
      this.getList();
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.listQuery.pageSize = val;

      this.getList(this.listQuery);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleClose(done) {
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => {})
    },
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log("表单验证", this.ruleForm);
          delete this.ruleForm.createTime;
          if (typeof this.ruleForm.servedRegions == "object") {
            // 服务案例
            this.ruleForm.servedRegions = this.ruleForm.servedRegions.join(",");
            // 资质信息
            this.ruleForm.qualifications = this.ruleForm.qualifications.join(
              ","
            );
            this.ruleForm.businessType = this.ruleForm.businessType.join(
              ","
            );
            
            this.ruleForm.largeArea = this.ruleForm.largeArea.join(",");
            // 品牌
            this.ruleForm.servedBrands = this.ruleForm.servedBrands.join(",");
          }
          const p = Object.assign(this.ruleForm, this.vicecaseList);
          console.log("提交的表单数据", p);

          let {
            id,
            reject,
            name,
            qualifications,
            businessType,
            regionId,
            cityId,
            betterAddress,
            contact,
            establishTime,
            turnOver,
            dialogImageUrlArray1,
            dialogImageUrlArray2,
            rankingPriority,
            registerCapital,
            servedRegions,
            qualificationPictures,
            banners,
            category,
            servedBrands,
            description,
            authenticationPictures,
            principal,
            certifiedCount,
            vedioUrl,
            projectsInTwoYears,
            warrantyDepositField,
            largeArea,
            youcaiMember,
            restAssured,
            advantageousServiceProvinces,
            vendorLabel
          } = p;

          let params;
          console.log(authenticationPictures);
          if (this.isadd) {
            params = {
              reject,
              name,
              qualifications,
              businessType,
              regionId: regionId ? regionId : "",
              cityId: cityId ? cityId : "",
              betterAddress,
              contact,
              establishTime,
              rankingPriority: rankingPriority ? rankingPriority : "",
              servedBrands,
              dialogImageUrlArray1,
              dialogImageUrlArray2,
              registerCapital: registerCapital ? registerCapital : "0",
              qualificationPictures,
              category,
              banners,
              turnOver,
              servedRegions,
              description,
              authenticationPictures: JSON.parse(
                JSON.stringify(authenticationPictures)
              ).join(","),
              principal: JSON.stringify(principal),
              certifiedCount,
              vedioUrl: this.videoPath ? this.videoPath : "",
              projectsInTwoYears: projectsInTwoYears || "",
              warrantyDepositField: warrantyDepositField || "",
              largeArea: largeArea,
              youcaiMember: youcaiMember || "",
              restAssured: restAssured || "",
              advantageousServiceProvinces: advantageousServiceProvinces || "",
              vendorLabel: vendorLabel || ""
            };
          } else {
            console.log("编辑111111111111");
            params = {
              id,
              reject,
              name,
              qualifications,
              businessType,
              regionId: regionId ? regionId : "",
              cityId: cityId ? cityId : "",
              betterAddress,
              category: category ? category : "",
              contact,
              establishTime: establishTime ? establishTime : "",
              rankingPriority: rankingPriority ? rankingPriority : "",
              servedBrands,
              dialogImageUrlArray1,
              dialogImageUrlArray2,
              registerCapital: registerCapital ? registerCapital : "0",
              qualificationPictures,
              banners,
              turnOver: turnOver ? turnOver : "",
              servedRegions,
              description,
              authenticationPictures: JSON.parse(
                JSON.stringify(authenticationPictures)
              ).join(","),
              principal: JSON.stringify(principal),
              certifiedCount,
              vedioUrl: this.videoPath ? this.videoPath : "",
              projectsInTwoYears: projectsInTwoYears || "",
              warrantyDepositField: warrantyDepositField || "",
              largeArea: largeArea,
              youcaiMember: youcaiMember || "",
              restAssured: restAssured || "",
              advantageousServiceProvinces: advantageousServiceProvinces || "",
              vendorLabel: vendorLabel || ""
            };
          }

          this.submitUpload1(params);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 服务地区
    handleTagClose(tag, index) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.ruleForm.servedRegions.splice(index, 1);
    },
    // 供应商资质
    handleQTagClose(tag, index) {
      this.qualificationsTags.splice(this.qualificationsTags.indexOf(tag), 1);
      this.ruleForm.qualifications.splice(index, 1);
    },
    // 供应商资质
    handleBTagClose(tag, index) {
      if (!this.roles) {
        this.$message.warning("当前账户禁止操作");
        return;
      }
      this.businessTypeTags.splice(this.businessTypeTags.indexOf(tag), 1);
      this.ruleForm.businessType.splice(index, 1);
    },
    handleLargeAreaTagsClose(tag, index) {
      if (!this.roles) {
        this.$message.warning("当前账户禁止操作");
        return;
      }
      const itemResult = this.largeAreaList.find(item=>item.name === tag);
      this.largeAreaTags = this.largeAreaTags.filter(item=>item != itemResult.name);
      this.ruleForm.largeArea = this.ruleForm.largeArea.filter(item=>item != itemResult.id);
      // this.largeAreaTags.splice(this.largeAreaTags.indexOf(tag), 1);
      // this.ruleForm.largeArea.splice(index, 1);
    },
    // 品牌
    handpinpaiClose(tag, index) {
      this.servedBrandstags.splice(this.servedBrandstags.indexOf(tag), 1);
      this.ruleForm.servedBrands.splice(index, 1);
      this.$forceUpdate();
      console.log("品牌信息", tag);
    },
    // 取消表单
    cancleForm() {
      this.showAddOrUpdate = false;
      this.ruleForm.qualifications = [];
      this.ruleForm.servedRegions = [];
      this.ruleForm.servedBrands = [];
      this.ruleForm.authenticationPictures = [];
      this.copyAuthenticationPictures = [];
      this.ruleForm.servedBrandsName = "";
      this.qualificationsTags = [];
      this.businessTypeTags = [];
      this.largeAreaTags = [];
      this.ruleForm.largeArea = [];
      this.ruleForm.projectsInTwoYears = "";
      (this.ruleForm.warrantyDepositField = "");
      // 服务
      this.dynamicTags = [];
      // 品牌
      this.servedBrandstags = [];
      this.initdata();
      this.isadd = false;
    },
    initdata() {
      this.selectBrands = [];
      this.isSelectAll = false;

      this.ruleForm.principal = [];
      this.ruleForm.servedRegions = [];
      // 资质信息
      this.ruleForm.qualifications = [];
      this.ruleForm.largeArea = [];
      // 品牌
      this.ruleForm.servedBrands = [];
      this.ruleForm.certifiedCount = "";
      // 清空  数据
      this.ruleForm.rankingPriority = "";
      this.ruleForm.name = "";
      // 品牌
      this.servedBrandstags = [];
      this.ruleForm.servedBrandsName = "";
      // 资质
      this.qualificationsTags = [];
      this.ruleForm.businessType = [];
      this.ruleForm.businessTypeNames = ""; 
      this.businessTypeTags = [];
      this.largeAreaTags = [];
      this.ruleForm.authenticationPictures = [];
      this.copyAuthenticationPictures = [];
      this.ruleForm.qualificationsNames = ""; // 用他来验证标签
      this.ruleForm.largeAreaNames = "";
      // 服务地区标签
      this.dynamicTags = [];
      this.ruleForm.servedRegionsNames = "";
      // 地点
      this.ruleForm.regionName = "";
      this.ruleForm.cityName = "";
      this.ruleForm.betterAddress = "";
      // 联系
      this.ruleForm.contact = "";
      // 成立时间
      this.ruleForm.establishTime = "";
      // 营业额
      this.ruleForm.turnOver = "";
      this.vicecaseList = {
        cityName: "",
        cityId: "", // 城市code
        regionId: "", // 省code
        regionName: "",
        betterAddress: "" // 详细地址
      };
      // 简介
      this.ruleForm.description = "";
    },
    // 新增供应商
    addProvider() {
      this.isadd = true;
      this.showAddOrUpdate = true;
      this.initdata();
      this.ruleForm.dialogImageUrlArray1 = [];
      this.ruleForm.dialogImageUrlArray2 = [];
      this.ruleForm.category = [];
    },
    categorysel(val) {
      this.ruleForm.category = val;
    },
    resetProvider() {
      this.listQuery = {
        category: 0,
        lists: "",
        state: 0,
        s: "0",
        sort: 0,
        pageSize: 10,
        pageNum: 1,
        searchName: ""
      };
      this.getList();
    },
    // 删除当前行
    deleteRow(rows) {
      this.$confirm("确认删除？")
        .then(_ => {
          //   done()
          //  rows.splice(index, 1)
          console.log("删除的id", rows.id);
          deleteVendor({ id: rows.id }).then(res => {
            if (res.data.code === 0) {
              this.$message({
                type: "success",
                message: "删除成功"
              });
            }

            this.getList();
          });
        })
        .catch(_ => {});
      //   rows.splice(index, 1)
    },
    // 查看
    showRow(rows) {
      this.showAddOrUpdate = true;
      this.ruleForm = {};
      window.scroll({ top: 0 });
      queryIdVendor({ id: rows.id }).then(res => {
        if (res.status || res.data.code === 0 || res.data.data.length !== 0) {
          const da = res.data.data;
          this.ruleForm = JSON.parse(JSON.stringify(da));
          if(!da.brands){
            this.selectBrands = []
          }else{
            this.selectBrands = da.brands.split(",")
          }
          if (!da.certifiedCount) {
            this.ruleForm.certifiedCount = "";
          } else {
            this.ruleForm.certifiedCount = da.certifiedCount;
          }
          if (!da.principalList) {
            this.ruleForm.principal = [];
          } else {
            this.ruleForm.principal = da.principalList;
          }
          if (!da.authenticationPictures) {
            this.ruleForm.authenticationPictures = [];
            this.copyAuthenticationPictures = [];
          } else {
            this.copyAuthenticationPictures = [];
            let authenticationPictures = this.ruleForm.authenticationPictures;

            this.ruleForm.authenticationPictures = authenticationPictures.split(
              ","
            );
            this.ruleForm.authenticationPictures.forEach((ele, index) => {
              this.copyAuthenticationPictures.push({ url: ele, name: index });
            });
          }
          // banner 详情图
          if (!da.banners) {
            // 图片
            this.ruleForm.dialogImageUrlArray1 = [];
          } else {
            let imglist = da.banners.split(",");
            let arrs = [];
            imglist.forEach(mimg => {
              arrs.push({ url: mimg });
            });
            this.ruleForm.dialogImageUrlArray1 = arrs;
          }
          // 案例查看
          if (!da.rankingPriority) {
            this.ruleForm.rankingPriority = da.ruleranking;
          }
          // 资质图
          if (!da.qualificationPictures) {
            // 图片
            this.ruleForm.dialogImageUrlArray2 = [];
          } else {
            let imglist = da.qualificationPictures.split(",");
            let arrs = [];
            imglist.forEach(mimg => {
              arrs.push({ url: mimg });
            });
            this.ruleForm.dialogImageUrlArray2 = arrs;
          }
          if (!this.addressoptions.list1) {
            this.fetchData();
          }
          if (da.regionId != null && da.regionId != "") {
            this.vicecaseList.regionId = da.regionId;
            this.getcity(this.vicecaseList.regionId);

            console.log("省", this.addressoptions);
            const arr = this.addressoptions.list1.filter(
              el => el.code == da.regionId
            );

            this.ruleForm.regionName = arr[0].name;
            this.vicecaseList.regionName = arr[0].name;
            this.vicecaseList.cityName = da.cityName;

            if (this.vicecaseList.regionId != "") {
              this.iscity = true;
            }
            this.vicecaseList.cityId = da.cityId;

            this.vicecaseList.betterAddress = da.betterAddress;
          } else {
          }

          if (da.servedBrands != null && da.servedBrands != "") {
            this.ruleForm.servedBrands = da.servedBrands.split(",");
          } else {
            this.ruleForm.servedBrands = [];
          }
          if (da.qualifications != null && da.qualifications != "") {
            this.ruleForm.qualifications = da.qualifications.split(",");
          } else {
            this.ruleForm.qualifications = [];
          }
          if (da.qualificationsNames != null && da.qualificationsNames != "") {
            // 资质
            this.qualificationsTags = da.qualificationsNames.split(",");
            this.ruleForm.qualificationsNames = "";
          } else {
            this.ruleForm.qualifications = [];
          }

          if (da.businessType != null && da.businessType != "") {
            this.ruleForm.businessType = da.businessType.split(",");
          } else {
            this.ruleForm.businessType = [];
          }
          if (da.businessType != null && da.businessType != "") {
            // 资质
            this.businessTypeTags = da.businessType.split(",");
            this.ruleForm.businessTypeNames = "";
          } else {
            this.ruleForm.businessType = [];
          }


          if (da.largeArea != null && da.largeArea != "") {
            this.ruleForm.largeArea = da.largeArea.split(",");
          } else {
            this.ruleForm.largeArea = [];
          }
          if (da.largeAreaNames != null && da.largeAreaNames != "") {
            // 资质
            this.largeAreaTags = da.largeAreaNames.split(",");
            this.ruleForm.largeAreaNames = "";
          } else {
            this.ruleForm.largeArea = [];
          }
          if (da.servedRegionsNames !== null && da.servedRegionsNames != "") {
            this.dynamicTags = da.servedRegionsNames.split(",");
            this.ruleForm.servedRegionsNames = "";
          } else {
          }
          if (da.servedBrandsName != null && da.servedBrandsName != "") {
            // 品牌
            this.servedBrandstags = da.servedBrandsName
              ? da.servedBrandsName.split(",")
              : [];
            this.ruleForm.servedBrandsName = "";
          } else {
            this.ruleForm.servedBrands = [];
          }
          if (da.servedRegions != "" && da.servedRegions != null) {
            this.ruleForm.servedRegions = da.servedRegions.split(",");
          } else {
            this.ruleForm.servedRegions = [];
          }
          if (da.vedioUrl != "" && da.vedioUrl != null) {
            this.isShowUploadVideo = true;
            this.videoFlag = false;
            this.videoUploadPercent = 0;
            this.videoPath = da.vedioUrl;
          } else {
            this.isShowUploadVideo = false;
            this.videoFlag = false;
            this.videoUploadPercent = 0;
            this.videoPath = "";
          }
          // if (
          //   da.qualificationsNames == null ||
          //   da.servedRegionsNames == null ||
          //   da.servedBrandsName == null
          // ) {
          // } else {

          // }
        }
      });
      // this.ruleForm = rows
    },

    citygetadress(val) {
      console.log("城市", val);
      this.vicecaseList.cityId = val;
    },
    getadress(val) {
      console.log("省", val);
      this.vicecaseList.regionId = val;
      this.getcity(val);
      this.iscity = true;
    },
    getcity(id) {
      console.log("省id", id);
      if (!id) {
        return;
      }
      const p = { regionCode: id };

      queryCity(p).then(res => {
        console.log("123", res);
        if (res.data.code === 0) {
          this.addressoptions.list2 = res.data.data;
          // const arr1 = this.addressoptions.list2.filter(el => el.id == id);
          // this.vicecaseList.cityName = arr1.length > 0 ? arr1[0].name : [];
        }
      });
    },
    chagePicker(time) {
      console.log("time:", time);
    },
    // 添加Tags
    addTags(item) {
      this.ruleForm.servedRegionsNames = "全部";
      let isarr = this.dynamicTags.filter(el => el == item.name);
      if (item.code != 0) {
        if (!isarr[0]) {
          this.dynamicTags.push(item.name);
          this.ruleForm.servedRegions.push(item.code);
        } else {
          this.$message.info("不可重复");
        }
      } else {
        this.$message.info("全部不可选");
      }
      // this.ruleForm.servedRegionsNames = "";
    },
    addBusinessTypeTags(item) {
      this.ruleForm.businessTypeNames = "全部";
      let isarr = this.businessTypeTags.filter(el => el == item.name);
      // console.log(isarr, this.qualificationsTags);
      if (item.code != 0) {
        if (!isarr[0]) {
          this.businessTypeTags.push(item.name);
          console.log(this.ruleForm.businessType);
          
          this.ruleForm.businessType.push(item.code);
        } else {
          this.$message.info("不可重复");
        }
      } else {
        this.$message.info("全部不可选");
      }
    },
    // 添加 资质Tagws
    addQulificationsTags(item) {
      console.log("资质标签", this.ruleForm.qualifications);
      this.ruleForm.qualificationsNames = "全部";
      let isarr = this.qualificationsTags.filter(el => el == item.name);
      // console.log(isarr, this.qualificationsTags);
      if (item.code != 0) {
        if (!isarr[0]) {
          this.qualificationsTags.push(item.name);
          this.ruleForm.qualifications.push(item.code);
        } else {
          this.$message.info("不可重复");
        }
      } else {
        this.$message.info("全部不可选");
      }

      console.log("a:ddd", this.qualificationsTags);
    },
    addLargeAreas(item) {
      let isarr = this.largeAreaTags.filter(el => el == item.name);
      // console.log(isarr, this.qualificationsTags);
      if (item.code != 0) {
        if (!isarr[0]) {
          this.largeAreaTags.push(item.name);
          this.ruleForm.largeArea.push(item.id);
        } else {
          this.$message.info("不可重复");
        }
      } else {
        this.$message.info("全部不可选");
      }
      console.log("a:ddd", this.largeAreaTags, this.ruleForm);
    },
    // 添加品牌
    addlogoOptionsTags(item) {
      // console.log(
      //   "标签纸",
      //   item,
      //   this.servedBrandstags,
      //   this.ruleForm.servedBrands
      // );
      this.ruleForm.servedBrandsName = "全部";
      let isarr = this.servedBrandstags.filter(el => el == item.name);
      console.log("是否有标签纸", isarr);
      if (item.code != 0) {
        if (!isarr[0]) {
          this.servedBrandstags.push(item.name);
          this.ruleForm.servedBrands.push(item.code);
        } else {
          this.$message.info("不可重复");
        }
      } else {
        this.$message.info("全部不可选");
      }
    },
    /// 1
    // 手动上传图片
    submitUpload1(data) {
      // fd.append("id", this.ruleForm.id);
      // 读取文件遍历到file 里面

      // fileBanners  fileQualificationPictures
      // banners  qualificationPictures
      this.loading = true;

      let params = data;
      // 图片处理
      console.log("上传参数", data);
      let imglist1 = params.dialogImageUrlArray1;
      let imglist2 = params.dialogImageUrlArray2;

      let f = new FormData();
      let banners = [],
        qualificationPictures = [];
      // banner 图片
      imglist1.forEach(item => {
        if (item.status == "success") {
          banners.push(item.url);
        } else {
          f.append("fileBanners", item.raw, item.raw.name);
        }
      });
      // 资质图片
      imglist2.forEach(item => {
        if (item.status == "success") {
          qualificationPictures.push(item.url);
        } else {
          f.append("fileQualificationPictures", item.raw, item.raw.name);
        }
      });
      params.qualificationPictures = qualificationPictures.join();
      params.banners = banners.join();
      params.brands = this.selectBrands.join();
      console.log("请求数据", params);
      for (let i in params) {
        f.append(i, data[i]);
      }

      // 请求完  成功清空数据或者 重新调用id

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + getToken()
        }
      }; //添加请求头
      // 新增施工队
      const loading = this.$loading({
        lock: false,
        text: "加载中 请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      if (this.isadd) {
        // id: 47
        // addressId: 81
        console.log("file", f.get("id"));
        addVendor(f)
          .then(res => {
            console.log("新增施工队", res);
            if (res.status == 200 && res.data.data == 1) {
              this.$message({
                message: `上传成功`
              });
              this.loading = false;
              this.getList();
              this.dialogImageUrlArray1 = [];
              this.form1.dialogImageUrl = "";
              this.isadd = false;
              this.showAddOrUpdate = false;
              this.selectBrands = [];
              this.isSelectAll = false;
              this.ruleForm.servedRegions = [];
              // 资质信息
              this.ruleForm.qualifications = [];
              this.ruleForm.largeArea = [];
              // 品牌
              this.ruleForm.servedBrands = [];
              // 资质
              this.qualificationsTags = [];

              this.businessTypeTags = [];
              // 服务
              this.dynamicTags = [];
              // 品牌
              this.servedBrandstags = [];
              this.ruleForm.authenticationPictures = [];
            } else {
              this.loading = false;
              this.$message({
                message: `上传失败`
              });
              this.ruleForm.servedRegions = [];
              // 资质信息
              this.ruleForm.qualifications = [];

              // 品牌
              this.ruleForm.servedBrands = [];
              // 资质
              this.qualificationsTags = [];

              // 资质
              this.businessTypeTags = [];
              // 服务
              this.dynamicTags = [];
              // 品牌
              this.servedBrandstags = [];
              this.ruleForm.authenticationPictures = [];
            }
          })
          .finally(() => {
            loading.close();
          });
        // axios.post("v/v1/vendor/addVendor", f, config).then(res => {});
      } else {
        console.log("编辑111");
        updateVendor(f)
          .then(res => {
            console.log("涂上韩", res);
            if (res.status == 200 && res.data.data == 1) {
              this.$message({
                message: `上传成功`
              });
              this.dialogImageUrlArray1 = [];

              this.form1.dialogImageUrl = "";
              this.loading = false;
              this.showAddOrUpdate = false;
              this.initdata();
              this.getList();
            } else {
              this.$message({
                message: `上传失败`
              });
              this.initdata();
            }
          })
          .finally(() => loading.close());

        this.loading = false;
      }
      this.loading = false;
    },

    onChange1(file, fileList) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"; // 图片类型
      const isLt2M = file.size / 1024 / 1024 < 5; // 图片大小
      if (isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
        fileList.pop();
      }
      let existFile = fileList
        .slice(0, fileList.length - 1)
        .find(f => f.name === file.name);
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
        fileList.pop();
      }
      if (existFile) {
        this.$message.error("当前文件已经存在!");
        fileList.pop();
      }
      console.log("改变", file, fileList);
      this.dialogImageUrlArray1 = fileList;
    },
    // 点击已上传的文件链接时的钩子
    handlePictureCardPreview1(file) {
      console.log("点击已上传", file);
      this.form.imageUrlIdPhone = file.url;
      this.form.dialogVisible1 = true;
    },

    // 上传文件之前的钩子
    beforeAvatarUpload1(file) {
      console.log("图片正在上传", file);
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"; // 图片类型
      const isLt2M = file.size / 1024 / 1024 < 2; // 图片大小

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 证件照上传成功时的钩子
    handleAvatarSuccess1(res, file, h) {
      console.log("证件照上传成功", res, h);
      console.log("测试", file);
      if (res.errorCode == 0) {
        this.imageUrlIdPhone = res.result;
      }
      // this.imageUrlIdPhone = URL.createObjectURL(file.raw);
    },
    // 移除图片
    handleRemove1(file, fileList) {
      // console.log(file, fileList);
      this.ruleForm.dialogImageUrlArray1 = fileList;
      console.log("移除图片", file, fileList);
      this.form1.dialogImageUrl = "";
    },
    //
    handleRemove2(file, fileList) {
      console.log("移除图片", file, fileList);
      // console.log(file, fileList);
      this.imageUrlIdPhone = "";
      this.ruleForm.dialogImageUrlArray2 = fileList;
    },

    ///// 2
    // 手动上传图片

    // 首页详情图片
    onChange1(file, fileList) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"; // 图片类型
      const isLt2M = file.size / 1024 / 1024 < 5; // 图片大小
      if (isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
        fileList.pop();
      }
      let existFile = fileList
        .slice(0, fileList.length - 1)
        .find(f => f.name === file.name);
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
        fileList.pop();
      }
      if (existFile) {
        this.$message.error("当前文件已经存在!");
        fileList.pop();
      }
      console.log("改变", file, fileList);
      this.ruleForm.dialogImageUrlArray1 = fileList;
    },
    // 资质图片上传
    onChange2(file, fileList) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"; // 图片类型
      const isLt2M = file.size / 1024 / 1024 < 5; // 图片大小
      if (isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
        fileList.pop();
      }
      let existFile = fileList
        .slice(0, fileList.length - 1)
        .find(f => f.name === file.name);
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
        fileList.pop();
      }
      if (existFile) {
        this.$message.error("当前文件已经存在!");
        fileList.pop();
      }
      console.log("改变", file, fileList);
      console.log("当前所有文件", this.ruleForm);
      this.ruleForm.dialogImageUrlArray2 = fileList;
    },

    // 点击已上传的文件链接时的钩子
    handlePictureCardPreview2(file) {
      console.log("点击已上传", file);
      this.imageUrlIdPhone = file.url;
    },

    // 上传文件之前的钩子
    beforeAvatarUpload2(file) {
      console.log("图片正在上传", file);
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"; // 图片类型
      const isLt2M = file.size / 1024 / 1024 < 2; // 图片大小

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 证件照上传成功时的钩子
    handleAvatarSuccess2(res, file, h) {
      console.log("证件照上传成功", res, h);
      console.log("测试", file);
      if (res.errorCode == 0) {
        this.imageUrlIdPhone = res.result;
      }
      // this.imageUrlIdPhone = URL.createObjectURL(file.raw);
    },
    //上传前回调
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 300;
      if (["video/mp4"].indexOf(file.type) == -1) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!fileSize) {
        this.$message.error("视频大小不能超过300MB");
        return false;
      }
      this.isShowUploadVideo = false;
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleVideoSuccess(res, file) {
      console.log(res);
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      //后台上传地址
      if (res.code == 0) {
        this.videoPath = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    videoRemove() {
      this.videoFlag = false;
      this.videoPath = "";
      this.videoUploadPercent = 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.select-brand-all {
  height: 34px;
  display: flex;
  padding: 0 20px;
  align-items: center;
  /deep/ .el-checkbox {
    width: 100%;
  }
  /deep/ .el-checkbox__input {
    display: none !important;
  }
  /deep/ .is-checked {
    font-weight: bold;
  }
  /deep/ .el-checkbox__label {
    padding-left: 0 !important;
  }
}
.video-box {
  position: relative;
  width: fit-content;

  .video-delete {
    position: absolute;
    top: 20px;
    right: 20px;
    display: none;
    cursor: pointer;
    color: #ffffff;
  }

  .video-avatar {
    width: 200px;
  }
}

.video-box:hover .video-delete {
  display: block;
}

.fliter-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.principal-list {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .principal-item {
    width: 150px;
    // height: 220px;
    display: flex;
    flex-direction: column;
    margin-right: 10px;
    position: relative;

    .delete-principal-item {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
      color: #e03131;
    }

    img {
      width: 150px;
      height: 180px;
      border-radius: 10px;
    }

    .info {
      width: 100%;
      // height: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      span {
        // height: 50%;
        display: block;
        width: 100%;
      }
    }
  }
}

.container {
  padding: 24px;
  background: #fff;
}

.pagecontent {
  height: 40vh;
  height: 100%;
}

.outimg {
  font-size: 14px;
  // color: rgb(241, 33, 33);
  padding: 10px 0;
}

.input_right {
  padding-left: 10px;
  font-size: 14px;
  min-width: 64px;
  color: #b3b3b3;
}

.mycolor {
  color: rgba(17, 130, 251, 1) !important;
}

.myredcolor {
  font-size: 20 rpx;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff5d5dff !important;
}

.mygraycolor {
  font-size: 20 rpx;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #b3b3b3 !important;
}

.filter {
  height: 76px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  .filter-select {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .filter-title {
      font-size: 14px;
      color: #333;
      margin-right: 6px;
      cursor: pointer;
    }

    .select-width {
      width: 120px;
      margin-right: 20px;
    }
  }

  .filter-btn {
    display: flex;
    //min-width: 150px;
    //flex-wrap: wrap;
    //justify-content: space-between;

    .button {
      margin-left: 0 !important;
      margin-top: 10px;
    }

    // align-items: center;
  }
}

.red-text {
  color: #ff5d5d;
  font-size: 14px;
}

.blue-text {
  color: #1182fb;
  font-size: 14px;
}

.green-text {
  color: #1cd0bd;
  font-size: 14px;
}

.gray-text {
  color: #b3b3b3;
  font-size: 14px;
}

.paging {
  margin-top: 50px;
  text-align: center;
}

.bottom-btn {
  text-align: center;
}

.baseinfo {
  display: flex;

  .el-row {
    width: 100%;
  }

  .left-content {
    padding-top: 24px;
    padding-bottom: 24px;
    padding-right: 34px !important; // el-row 布局自带padding左右10px
    padding-left: 34px !important;

    background-color: #fff;
    border-radius: 10px;
  }

  .lrflex .el-row {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }

  .baseinfo-title {
    font-size: 20px;
    color: #333;
  }

  .solid {
    margin-top: 21px;
    border: 1px solid #f0f0f0;
    margin-bottom: 38px;
  }

  .width304 {
    width: 185px;
  }

  .width348 {
    width: 348px;
  }

  .width99 {
    width: 99px;
  }

  // .width650 {
  //   width: 650px;
  // }
  .width164 {
    width: 260px;
  }

  .width220 {
    width: 220px;
  }

  .hotel {
    padding: 24px;
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 10px;

    .title-text {
      font-size: 20px;
      color: #333;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .upload-image {
      margin-top: 16px;
    }

    .hotel-text {
      margin-top: 16px;
      font-size: 16px;
      color: #000;
    }
  }

  .address_style {
    display: flex;
    align-items: center;

    .address-right {
      display: flex;
      align-items: center;
    }
  }
}
</style>
